import * as React from 'react';
import { SVGProps } from 'react';

const AstronautUpsellBanner = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="145"
    height="144"
    fill="none"
    viewBox="0 0 145 144"
    {...props}
  >
    <mask
      id="mask0_642_74788"
      style={{ maskType: 'alpha' }}
      width="145"
      height="144"
      x="0"
      y="0"
      maskUnits="userSpaceOnUse"
    >
      <path fill="#D9D9D9" d="M0 0H145V143.4H0z"></path>
    </mask>
    <g mask="url(#mask0_642_74788)">
      <path
        fill="#FFD100"
        d="M109.11 22.407l-.405-1.149a.972.972 0 01.395-1.148l10.768-6.943a.979.979 0 011.482.587l1.124 4.54a.98.98 0 01-.663 1.173l-11.487 3.557a.978.978 0 01-1.214-.612v-.005zM111.16 27.076l5.94.607a.98.98 0 01.845 1.24l-.561 2.024a.985.985 0 01-1.281.663l-5.657-2.044a.98.98 0 01-.552-1.346l.284-.592a.973.973 0 01.987-.552h-.005zM105.06 17.928a.983.983 0 01-.653-1.184l1.629-6.306a.977.977 0 011.245-.688l2.439.77a.98.98 0 01.496 1.518l-4.074 5.535a.98.98 0 01-1.088.355h.006z"
      ></path>
      <path
        fill="#1F93CB"
        d="M96.796 37.5l-1.533-9.721a2.57 2.57 0 012.135-2.94c1.402-.223 2.556.774 2.94 2.135.86 3.046 1.366 6.224 1.533 9.72.066 1.418-.733 2.718-2.135 2.94a2.57 2.57 0 01-2.94-2.135z"
      ></path>
      <path
        stroke="#42A9DB"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="12.099"
        d="M106.569 156.224l-17.448-43.381"
      ></path>
      <path
        stroke="#F1F1F1"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="15.823"
        d="M89.121 112.843l12.539 30.958"
      ></path>
      <path
        fill="#F1F1F1"
        d="M108.616 141.791l-13.514 5.15a1.276 1.276 0 00-.738 1.646l1.7 4.459c.25.658.987.988 1.645.737l13.514-5.15c.658-.25.989-.987.738-1.645l-1.699-4.459a1.276 1.276 0 00-1.646-.738z"
      ></path>
      <path
        stroke="#42A9DB"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="12.099"
        d="M69.633 162.616l.37-46.757"
      ></path>
      <path
        stroke="#F1F1F1"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="15.823"
        d="M70.004 115.859l-.344 33.403"
      ></path>
      <path
        fill="#42A9DB"
        d="M66.017 70.16c18.546 0 33.58-15.035 33.58-33.58C99.597 18.034 84.563 3 66.017 3c-18.545 0-33.58 15.034-33.58 33.58 0 18.545 15.035 33.58 33.58 33.58z"
      ></path>
      <path
        fill="#AC5E27"
        d="M66.147 17.377l-2.384.374c-10.45 1.65-17.862 10.166-16.218 20.61l1.457 9.347a3.096 3.096 0 003.543 2.575l34.252-5.404a3.096 3.096 0 002.576-3.542l-1.24-7.97c-1.65-10.45-11.542-17.645-21.992-16l.005.01z"
      ></path>
      <path
        fill="#EFAA83"
        d="M92.208 45.577a6.325 6.325 0 11-12.514 1.857 6.324 6.324 0 1112.509-1.857"
      ></path>
      <path
        fill="#E19B7C"
        d="M77.036 60.51l-10.263 1.619 1.372 8.683h.02-.015c.38 2.394 2.732 4.008 5.257 3.608l1.114-.177c2.525-.4 4.27-2.662 3.891-5.05v-.005l-1.371-8.684-.005.006z"
      ></path>
      <path
        fill="#EFAA83"
        d="M86.248 33.927l1.887 11.947a17.857 17.857 0 01.081 5c-.966 7.61-6.846 13.986-14.8 15.241l-1.55.243c-9.654 1.523-18.717-5.07-20.24-14.725l-1.888-11.948c-1.523-9.654 5.07-18.717 14.726-20.24l1.548-.243c9.655-1.524 18.718 5.07 20.241 14.725h-.005z"
      ></path>
      <path
        fill="#C8886D"
        d="M72.207 46.809l-2.55.402c-.546.086-.92.6-.833 1.146l.131.83c.086.546.6.92 1.146.833l2.55-.402c.546-.087.919-.6.833-1.146l-.131-.83c-.087-.547-.6-.92-1.146-.833z"
      ></path>
      <path
        fill="#7F1917"
        d="M78.531 50.836a.498.498 0 01.577.53c-.213 3.305-2.94 6.194-6.664 6.782-3.725.586-7.206-1.321-8.43-4.403a.503.503 0 01.389-.683l14.123-2.226h.005z"
      ></path>
      <mask
        id="mask1_642_74788"
        style={{ maskType: 'luminance' }}
        width="17"
        height="9"
        x="63"
        y="50"
        maskUnits="userSpaceOnUse"
      >
        <path
          fill="#fff"
          d="M78.531 50.836a.498.498 0 01.577.53c-.213 3.305-2.94 6.194-6.664 6.782-3.725.586-7.206-1.321-8.43-4.403a.503.503 0 01.389-.683l14.123-2.226h.005z"
        ></path>
      </mask>
      <g mask="url(#mask1_642_74788)">
        <path
          fill="#fff"
          d="M76.811 53.063l-10.082 1.59a1.095 1.095 0 01-1.25-.908l-.13-.825 12.241-1.932.13.824a1.095 1.095 0 01-.909 1.25z"
        ></path>
        <path
          fill="#D47E79"
          d="M73.441 64.385c2.477-.39 4.196-2.532 3.841-4.782-.355-2.25-2.65-3.756-5.127-3.365-2.476.39-4.195 2.531-3.84 4.781.355 2.25 2.65 3.757 5.126 3.366z"
        ></path>
      </g>
      <path
        stroke="#231F20"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.412"
        d="M61.559 46.696c.04-1.594 2.96-2.515 3.85-.511M76.32 44.667c.04-1.594 2.96-2.515 3.851-.511"
      ></path>
      <path
        fill="#C98A6D"
        d="M87.246 48.208c0 .748-.045 1.492-.136 2.221-.35.324-.835.567-1.397.653-1.234.192-2.353-.42-2.505-1.367-.151-.946.73-1.872 1.964-2.07.83-.13 1.609.102 2.075.563z"
        opacity="0.4"
      ></path>
      <path
        fill="#EFAA83"
        d="M59.168 50.89a6.324 6.324 0 01-5.329 7.18 6.324 6.324 0 01-7.18-5.328 6.324 6.324 0 0112.509-1.852z"
      ></path>
      <path
        fill="#C98A6D"
        d="M58.147 55.422c1.234-.194 2.113-1.12 1.963-2.067-.15-.947-1.27-1.556-2.505-1.361-1.234.194-2.113 1.12-1.963 2.067.15.947 1.27 1.556 2.505 1.361z"
        opacity="0.4"
      ></path>
      <path
        fill="#AC5E27"
        d="M51.659 50.318l1.19-.187a1.533 1.533 0 001.274-1.751L52.07 35.35l-3.163.5 2.222 14.083c.04.253.278.425.531.39v-.005z"
      ></path>
      <path
        fill="#E4E4E4"
        d="M78.048 122.325c9.661 0 17.493-7.832 17.493-17.493 0-9.662-7.832-17.494-17.493-17.494-9.661 0-17.493 7.832-17.493 17.494 0 9.661 7.832 17.493 17.493 17.493zM84.307 80.97a6.553 6.553 0 100-13.107 6.553 6.553 0 000 13.106zM62.721 84.373a6.553 6.553 0 100-13.106 6.553 6.553 0 000 13.106z"
      ></path>
      <path
        fill="#E4E4E4"
        d="M70.003 123.717a7.858 7.858 0 10-7.859-7.858 7.858 7.858 0 007.86 7.858zM89.12 120.7a7.858 7.858 0 100-15.717 7.858 7.858 0 100 15.717z"
      ></path>
      <path
        stroke="#F1F1F1"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="13.03"
        d="M84.309 74.414l17.888.04 6.745-12.068"
      ></path>
      <path
        fill="#F1F1F1"
        d="M56.204 79.01c2.01 12.742 4.787 30.316 4.787 30.316l34.663-5.47s-2.788-17.615-4.792-30.331a6.793 6.793 0 00-7.772-5.652l-21.233 3.36a6.8 6.8 0 00-5.653 7.772v.005z"
      ></path>
      <path
        fill="#F1F1F1"
        d="M96.888 111.658l-1.23-7.803-34.662 5.471 1.215 7.696a7.919 7.919 0 009.057 6.589l19.123-3.016c4.26-.673 7.175-4.676 6.502-8.937h-.005z"
      ></path>
      <path
        fill="#AC5E27"
        d="M49.043 29.384c1.123-2.712 2.813-4.767 4.625-6.639 2.57-2.434 6.209-4.382 9.817-4.949l2.439-.384c6.593-1.038 12.544 1.153 16.592 5.13 3.796 3.725 5 7.718 5.754 11.66l.06.394-2.985.47a7.49 7.49 0 01-8.567-6.233l.01.065a7.423 7.423 0 01-6.178 8.491l-22.65 3.573-.218-1.392c-.592-3.709.102-7.297 1.306-10.19l-.005.004z"
      ></path>
      <path
        stroke="#AC5E27"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.085"
        d="M57.422 16.404a5.372 5.372 0 00-2.014 7.328 5.377 5.377 0 00-5.13-2.698"
      ></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3.492"
        d="M48.566 19.06a21.526 21.526 0 0112.722-6.927M43.2 31.013c.156-1.361.44-2.697.84-3.982.364-1.174.83-2.308 1.386-3.396"
        opacity="0.3"
      ></path>
      <path
        fill="#fff"
        d="M67.866 67.265c16.752 0 30.331-13.58 30.331-30.331 0-16.752-13.58-30.331-30.33-30.331-16.752 0-30.332 13.58-30.332 30.33 0 16.752 13.58 30.332 30.331 30.332z"
        opacity="0.3"
      ></path>
      <path
        fill="#1F93CB"
        d="M36.356 47.102l-1.533-9.717a2.57 2.57 0 10-5.079.802l1.534 9.717a2.57 2.57 0 005.078-.802zM60.906 67.775L83 64.287c.79-.124 1.53.415 1.655 1.204l.103.655c.125.79-.414 1.53-1.204 1.655l-21.438 3.384a2.112 2.112 0 01-2.413-1.755 1.447 1.447 0 011.204-1.655z"
      ></path>
      <path
        fill="#26A4DC"
        d="M108.908 60.385c.881-.375 1.275-1.417.886-2.333l-2.505-5.905c-.39-.916-1.417-1.357-2.292-.982-.881.374-1.276 1.417-.886 2.333l2.505 5.905c.39.916 1.417 1.356 2.292.982z"
      ></path>
      <path
        fill="#26A4DC"
        d="M110.771 50.005l-3.222 3.85a5.53 5.53 0 108.48 7.095l3.221-3.85a5.53 5.53 0 00-.69-7.79 5.53 5.53 0 00-7.789.694z"
      ></path>
      <path
        stroke="#F1F1F1"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="13.253"
        d="M62.722 77.821l-16.82 8.45-13.117-7.883"
      ></path>
      <path
        fill="#26A4DC"
        d="M26.112 68.145a5.53 5.53 0 00-7.397 2.536 5.53 5.53 0 002.538 7.396l4.51 2.206a5.53 5.53 0 104.858-9.932l-4.509-2.206zM95.315 101.452l-34.572 6.153c-2.429.435-1.083 7.98 1.346 7.55l34.572-6.153c.425-.076.632-.461.642-.871.056-2.049-.253-4.377-1.088-6.087-.182-.37-.475-.668-.9-.592z"
      ></path>
      <path
        fill="#58B4E1"
        d="M85.847 111.981l-4.706.84c-1.235.223-2.424-.632-2.652-1.912l-.865-4.833c-.228-1.275.592-2.49 1.827-2.712l4.706-.84c1.234-.223 2.277.673 2.651 1.913.521 1.705.86 3.218.866 4.832 0 1.296-.593 2.49-1.827 2.712z"
      ></path>
      <path
        fill="#353584"
        d="M35.983 67.463L16.638 83.797c-1.266 1.068-3.158.886-4.236-.404L1.715 70.58c-1.073-1.29-.921-3.198.339-4.266L21.399 49.98c1.265-1.068 3.158-.886 4.236.405l10.687 12.812c1.073 1.29.92 3.198-.34 4.266z"
      ></path>
      <path
        fill="#3F3A94"
        d="M37.077 66.552L17.73 82.887c-1.265 1.067-3.157.885-4.235-.405L2.809 69.669c-1.073-1.29-.921-3.198.339-4.266L22.493 49.07c1.265-1.068 3.158-.886 4.236.405l10.687 12.812c1.073 1.29.92 3.198-.34 4.266z"
      ></path>
      <path
        fill="#D7EEF8"
        d="M34.965 66.334L17.88 80.755a2.62 2.62 0 01-3.704-.313L4.927 69.35a2.656 2.656 0 01.334-3.725l17.083-14.421a2.62 2.62 0 013.704.313l9.25 11.092a2.656 2.656 0 01-.334 3.725z"
      ></path>
      <path
        fill="#F4B268"
        d="M16.875 70.492l8.132-6.928a1.355 1.355 0 10-1.756-2.06L15.12 68.43c-.57.486-.64 1.341-.155 1.91.485.57 1.34.637 1.91.151z"
      ></path>
      <path
        fill="#26A7DF"
        d="M23.802 54.726l.263-.223-.223-.263a.205.205 0 01.02-.283.205.205 0 01.284.02l.223.263.263-.223a.205.205 0 01.283.02c.071.081.061.213-.02.284l-.263.223.223.263c.07.086.06.212-.02.283a.205.205 0 01-.284-.02l-.223-.263-.263.222a.205.205 0 01-.283-.02.205.205 0 01.02-.283z"
        opacity="0.4"
      ></path>
      <path
        fill="#3F3A93"
        d="M14.633 76.511l.33-.278-.28-.329a.25.25 0 01.031-.354.25.25 0 01.354.03l.279.33.329-.279a.25.25 0 01.354.03.25.25 0 01-.03.355l-.33.278.279.329a.25.25 0 01-.03.354.25.25 0 01-.355-.03l-.278-.33-.329.28a.25.25 0 01-.354-.031.25.25 0 01.03-.355zM23.227 71.284l.329-.279-.279-.329a.25.25 0 01.03-.354.25.25 0 01.355.03l.278.33.33-.279a.25.25 0 01.354.03.25.25 0 01-.03.355l-.33.278.279.329a.25.25 0 01-.03.354.25.25 0 01-.355-.03l-.278-.33-.33.279a.25.25 0 01-.354-.03.25.25 0 01.03-.355zM17.827 63.652a.972.972 0 100-1.944.972.972 0 000 1.944z"
        opacity="0.4"
      ></path>
      <path
        fill="#26A7DF"
        d="M31.296 64.896a.972.972 0 100-1.943.972.972 0 000 1.943zM9.107 67.573a.693.693 0 100-1.386.693.693 0 000 1.386z"
        opacity="0.4"
      ></path>
      <path
        fill="#fff"
        d="M7.805 63.486l18.14 10.47 4.712-3.973L12.51 59.508l-4.706 3.978zM4.383 68.368l16.74 9.66 3.132-2.641-18.146-10.47-.87.734a2.654 2.654 0 00-.856 2.717zM15.727 56.79l18.146 10.47 1.067-.907a2.656 2.656 0 00.921-2.398L18.86 54.143l-3.132 2.642v.005z"
        opacity="0.2"
      ></path>
      <path
        fill="#26A4DC"
        d="M32.06 76.62c-.986.081-1.852-.683-1.938-1.71l-.506-5.981c-.086-1.027.643-1.928 1.625-2.01.986-.08 1.852.684 1.938 1.711l.506 5.982c.086 1.027-.643 1.928-1.625 2.008z"
      ></path>
    </g>
  </svg>
);

export default AstronautUpsellBanner;
